/**
 * Empty state padrão Centrão — usado em listas/tabelas vazias.
 *
 * Uso:
 *   <EmptyState icone="bi-inbox" titulo="Nenhuma solicitação"
 *               texto="As solicitações pendentes aparecem aqui." />
 *
 *   <EmptyState icone="bi-stars" titulo="Bem-vindo!" cor="laranja"
 *               texto="..."
 *               acao={<button className="btn-primary-arq">Começar</button>} />
 */
export default function EmptyState({
  icone = 'bi-inbox',
  titulo,
  texto,
  cor = 'verde',        // 'verde' | 'laranja' | 'neutro'
  acao = null,          // opcional: botão/link de CTA
}) {
  const corIcone = {
    verde:   'var(--primary-light)',
    laranja: 'var(--accent-soft)',
    neutro:  '#E5E7EB',
  }[cor] || 'var(--primary-light)';

  const corIconeTexto = {
    verde:   'var(--primary)',
    laranja: 'var(--accent)',
    neutro:  '#9CA3AF',
  }[cor] || 'var(--primary)';

  return (
    <div className="empty-state">
      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 72,
        height: 72,
        borderRadius: '50%',
        background: corIcone,
        marginBottom: 16,
      }}>
        <i className={`bi ${icone}`} style={{ fontSize: '2rem', color: corIconeTexto }} />
      </div>
      {titulo && <div className="empty-state-title">{titulo}</div>}
      {texto && <div className="empty-state-text">{texto}</div>}
      {acao && <div style={{ marginTop: 20 }}>{acao}</div>}
    </div>
  );
}
